module.exports = __webpack_public_path__ + "static/img/splj_pic3.1.a15e833.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/solution/panels/img/advantage/splj_pic3.1.png
// module id = pTVR
// module chunks = 0